import { ColDef } from 'ag-grid-community';
import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import '../../../style.scss';

import { IConditionSV2, IDetailGroup, IVConditionFilterV2 } from '../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { GROUPTYPE, IDataFilterGroupList, IPagination } from '../../AddGroup/AddNewGroup';
import EG_CustomerList from './EG_CustomerList';
import EG_Decentralization, { ISelectedUserAccount } from './EG_Decentralization';
import { ISelectedCustomer } from '../EditGroup';
dayjs.locale('vi');

interface props {
    isLoadingTableModal: boolean
    selectedIdCustomerV9: ISelectedCustomer[]
    selectedIdAccount: ISelectedUserAccount[]

    tableDataNoCondCustomer: any[];


    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>
    setSelectedIdAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
    setModalCondition: (visible: boolean) => void;

    //Kh có dk
    memoizedColumnDefs: ColDef<any, any>[];
    infoOperator: IVConditionFilterV2
    inforGroup: IDetailGroup

    dataFilterListCondUnmatchedCustomers: IDataFilterGroupList

    paginationCondMatchedCustomers: IPagination;
    paginationCondUnmatchedCustomers: IPagination;

    selectedIdCondUnmatchedCustomers: Set<number>

    tableDataCondMatchedCustomers: any[];
    tableDataCondUnmatchedCustomers: any[];

    setDataFilterListCondUnmatchedCustomers: (dataFilterList: IDataFilterGroupList) => void;
    onPaginationCondUnmatchedCustomers: (page: number, pageSize: number) => void;
    onPaginationCondMatchedCustomers: (page: number, pageSize: number) => void;
    setSelectedIdCondUnmatchedCustomers: (data: Set<number>) => void;
    //Kh có dk

    // Kh có dk All
    tableDataCondCustomerAll: any[]
    paginationCondAll: IPagination
    onPaginationChangeCondAll: (page: number, pageSize: number) => void;
}

const EG_ConditionComponent: React.FC<props> = ({

    isLoadingTableModal,
    //Kh có dk
    dataFilterListCondUnmatchedCustomers,
    tableDataNoCondCustomer,
    paginationCondUnmatchedCustomers, tableDataCondUnmatchedCustomers,
    selectedIdCondUnmatchedCustomers,
    memoizedColumnDefs, tableDataCondMatchedCustomers,
    setSelectedIdCondUnmatchedCustomers, onPaginationCondUnmatchedCustomers, setDataFilterListCondUnmatchedCustomers,
    paginationCondMatchedCustomers,
    //Kh có dk
    inforGroup, selectedIdCustomerV9,
    selectedIdAccount,
    infoOperator,
    setSelectedIdCustomerV9, setSelectedIdAccount, onPaginationCondMatchedCustomers,

    // Kh có dk All
    tableDataCondCustomerAll,
    paginationCondAll,
    onPaginationChangeCondAll,
    setModalCondition,
}) => {

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>,
            children:
                <EG_CustomerList
                    isLoadingTableModal={isLoadingTableModal}
                    memoizedColumnDefs={memoizedColumnDefs}
                    tableDataNoCondCustomer={tableDataNoCondCustomer}
                    infoOperator={infoOperator}

                    selectedIdCustomerV9={selectedIdCustomerV9}

                    setSelectedIdCustomerV9={setSelectedIdCustomerV9}
                    setModalCondition={setModalCondition}
                    //Kh có dk
                    dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}
                    paginationCondMatchedCustomers={paginationCondMatchedCustomers}
                    paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}
                    selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}
                    tableDataCondMatchedCustomers={tableDataCondMatchedCustomers}
                    tableDataCondUnmatchedCustomers={tableDataCondUnmatchedCustomers}

                    setSelectedIdCondUnmatchedCustomers={setSelectedIdCondUnmatchedCustomers}
                    setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}
                    onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}
                    onPaginationCondMatchedCustomers={onPaginationCondMatchedCustomers}

                    //Kh có dk



                    // Kh có dk All
                    tableDataCondCustomerAll={tableDataCondCustomerAll}
                    paginationCondAll={paginationCondAll}
                    onPaginationChangeCondAll={onPaginationChangeCondAll}
                />,
        },
        ...(inforGroup?.status === GROUPTYPE.SHARED
            ? [
                {
                    key: '2',
                    label: (
                        <span className="custom-page-css text-base font-regular">
                            Phân quyền
                        </span>
                    ),
                    children: (
                        <EG_Decentralization
                            inforGroup={inforGroup}
                            setSelectedIdAccount={setSelectedIdAccount}
                        />
                    ),
                },
            ]
            : []),
    ];

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            <div className="custom-page-css w-full flex gap-2 items-center">
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />

            </div>

        </div>
    )
}

export default React.memo(EG_ConditionComponent)
